/** A quiet explanation under a search box when the syntax does not do what it looks like, with a one-click fix. */
import { useMemo } from 'react';
import { searchHints } from '../lib/searchhints.ts';
import { cx } from '../design/primitives.tsx';

export function SearchHint({ q, onFix, className }: { q: string; onFix: (query: string) => void; className?: string }) {
  const hints = useMemo(() => searchHints(q), [q]);
  if (hints.length === 0) return null;
  return (
    <div role="status" className={cx('flex flex-col gap-1.5 rounded-chip bg-n3 px-3 py-2 text-micro text-n9 max-w-2xl', className)}>
      {hints.map((h) => (
        <p key={h.id} className="m-0 flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <span>{h.message}</span>
          {h.fix && (
            <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onFix(h.fix!.query)}
              className="bg-transparent border-0 p-0 cursor-pointer text-micro font-medium text-accent underline underline-offset-2">
              {h.fix.label}
            </button>
          )}
        </p>
      ))}
    </div>
  );
}
